/* Paw Cycle — interacciones livianas (sin dependencias) */
(function () {
  function productArea() {
    return document.querySelector('[data-pc-cod-area]') || document.querySelector('.product-form') || document.querySelector('[id^="MainProduct-"]');
  }

  // Importante: NO interceptamos ni "presionamos" el botón de Releasit. Releasit convierte cada enlace
  // <a href="/rsi-btn-hook"> en su propio botón y maneja el clic. Si lo tocamos, se genera un ciclo que congela la página.

  // Enlaces "#MainProduct": bajan suavemente hasta la zona de compra.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#MainProduct"]');
    if (!link) return;
    var area = productArea();
    if (!area) return;
    e.preventDefault();
    area.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // Tarjetas de oferta por cantidad: marcan la opción y ajustan la cantidad.
  document.addEventListener('click', function (e) {
    var offer = e.target.closest('.pc-offer');
    if (!offer) return;
    var group = offer.closest('.pc-offers');
    group.querySelectorAll('.pc-offer').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
    offer.classList.add('is-active');
    offer.setAttribute('aria-checked', 'true');
    var qty = parseInt(offer.dataset.qty, 10) || 1;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.querySelectorAll('[data-pc-sticky-price]').forEach(function (el) { if (offer.dataset.price) el.textContent = offer.dataset.price; });
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('pc-offer')) {
      e.preventDefault();
      e.target.click();
    }
  });

  // Pack elegido en la página → mismo pack marcado dentro del formulario de Releasit.
  // Solo miramos si el formulario está abierto y tocamos la TARJETA del pack (nunca el botón de Releasit).
  function pageQty() {
    var active = document.querySelector('.pc-offers .pc-offer.is-active');
    return active ? (parseInt(active.dataset.qty, 10) || 1) : 0;
  }
  function rsiBusy() {
    try { var s = window._rsiV2 && window._rsiV2.getState(); return !!(s && s.loadingState && s.loadingState.isLoading); } catch (err) { return false; }
  }
  var rsiOpenSince = 0, rsiDone = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.isTrusted && e.target.closest && e.target.closest('label.rsi-quantity-product')) rsiDone = true; // el cliente eligió dentro: respetamos
  }, true);
  setInterval(function () {
    var dialog = document.getElementById('rsi_form_wrapper');
    var labels = dialog && dialog.open ? dialog.querySelectorAll('label.rsi-quantity-product') : [];
    if (!labels.length) { rsiOpenSince = 0; rsiDone = false; return; }
    if (!rsiOpenSince) rsiOpenSince = Date.now();
    if (rsiDone || Date.now() - rsiOpenSince < 600 || rsiBusy()) return;
    rsiDone = true;
    var want = pageQty();
    if (!want) return;
    for (var i = 0; i < labels.length; i++) {
      var title = labels[i].querySelector('.rsi-quantity-title');
      var m = title && title.textContent.match(/\d+/);
      var qty = m ? parseInt(m[0], 10) : i + 1;
      var radio = labels[i].querySelector('input[type="radio"]');
      if (qty === want) { if (radio && !radio.checked) labels[i].click(); break; }
    }
  }, 250);

  // Fecha estimada de entrega (días hábiles, sin fines de semana ni feriados de Chile).
  var HOLIDAYS = ['2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25', '2027-01-01'];
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      if (d.getDay() !== 0 && d.getDay() !== 6 && HOLIDAYS.indexOf(iso) === -1) days--;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' });
  }
  document.querySelectorAll('[data-pc-delivery]').forEach(function (el) {
    var now = new Date();
    var min = parseInt(el.dataset.min, 10) || 2;
    var max = parseInt(el.dataset.max, 10) || 5;
    var out = el.querySelector('[data-pc-delivery-range]');
    if (out) out.textContent = 'entre el ' + fmt(addBusinessDays(now, min)) + ' y el ' + fmt(addBusinessDays(now, max));
  });

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Aparición al hacer scroll: se aplica sola a los elementos de las secciones propias.
  var REVEAL = [
    ['.pc-head', ''], ['.pc-card', ''], ['.pc-benefit', 'left'], ['.pc-feel__item', ''], ['.pc-feel__media', 'zoom'],
    ['.pc-roadmap__item', 'left'], ['.pc-step', ''], ['.pc-ingredient', ''], ['.pc-review', ''], ['.pc-compare', 'zoom'],
    ['.pc-problem__item', ''], ['.pc-problem__answer', ''], ['.pc-stat', ''], ['.pc-stack', 'zoom'], ['.pc-bundle', 'zoom'],
    ['.pc-benefits__media', 'zoom'], ['.pc-final', ''], ['.pc-guarantee', ''], ['.pc-trust__item', ''], ['.pc-video', 'zoom'],
    ['.pc-hero__media', 'right'], ['.pc-ingredients__hero', 'zoom'], ['.pc-faq details', '']
  ];
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    REVEAL.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (el) {
        var siblings = el.parentNode ? Array.prototype.filter.call(el.parentNode.children, function (c) { return c.matches(pair[0]); }) : [];
        el.style.setProperty('--pc-i', Math.min(siblings.indexOf(el), 6));
        el.classList.add('pc-reveal');
        if (pair[1]) el.classList.add('pc-reveal--' + pair[1]);
        io.observe(el);
      });
    });
  }

  // Cifras que cuentan hacia arriba al aparecer.
  var counters = document.querySelectorAll('[data-pc-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        co.unobserve(en.target);
        var el = en.target, end = parseFloat(el.dataset.pcCount) || 0;
        if (reduceMotion || end === 0) { el.textContent = end; return; }
        var start = null, dur = 1400;
        (function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        })(performance.now());
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { c.textContent = '0'; co.observe(c); });
  }

  // Cuentas regresivas dentro de la página ([data-pc-countdown="fecha ISO"]).
  document.querySelectorAll('[data-pc-countdown]').forEach(function (box) {
    var end = Date.parse(box.getAttribute('data-pc-countdown'));
    if (isNaN(end) || end <= Date.now()) return;
    box.hidden = false;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var t = Math.max(0, end - Date.now());
      if (t === 0) { box.hidden = true; clearInterval(timer); return; }
      box.querySelector('[data-d]').textContent = pad(Math.floor(t / 864e5));
      box.querySelector('[data-h]').textContent = pad(Math.floor(t / 36e5) % 24);
      box.querySelector('[data-m]').textContent = pad(Math.floor(t / 6e4) % 60);
      box.querySelector('[data-s]').textContent = pad(Math.floor(t / 1e3) % 60);
    };
    var timer = setInterval(tick, 1000);
    tick();
  });

  // Barra fija de compra en móvil: aparece cuando el botón de compra sale de la pantalla.
  var sticky = document.querySelector('.pc-sticky');
  var target = productArea();
  if (sticky && target && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', hidden);
    }).observe(target);
  }
})();
